export default {
  bank_product: {
    complete_msg:
      'We sincerely thank you for <span>subscribing to the product</span>, and we will repay you with a better product.',
  },
  check: 'Check',
  verification_code: 'Verification code',
  enter_amount: 'Please enter the amount.',
  reg_complete: 'Registration completed',
  subscription_details: 'Subscription details',
  select_withdrawal_account: 'Select withdrawal account',
  email_address: 'Email Address',
  product_info: 'Product information',
  new_amount: 'New amount',
  min_running_amount: 'Minimum execution amount ',
  max_running_amount: 'Maximum execution amount ',
  product_type: 'Product type',
  bank_product_name: 'product name',
  reg_start_date: 'Subscription start date',
  reg_end_date: 'Subscription end date ',
  exec_start_date: 'Start date of execution ',
  exec_end_date: 'Execution end date ',
  basic_info: 'Basic Information',
  not_applicable: 'Not applicable',
  subscription: 'Subscribe',
  service_prepare: 'Service is being prepared.',
  no_buy_list: 'There is no purchase history.',
  no_sell_list: 'There is no sales history.',
  no_list: 'There is no list.',
  locale_name: 'English',
  Sale_registration: 'Sale registration',
  apply: 'Apply',
  status: 'Status',
  wallet: 'Wallet',
  wallet_address: 'Wallet address',
  wallet_transfer: 'Wallet transfer',
  buy: 'Buy',
  sell: 'Sell',
  all: 'All',
  breakdown: 'Breakdown',
  act_buy: 'Buy',
  act_sell: 'Sell',
  asset: 'Asset',
  select: 'Select',
  no_select: 'No choice',
  account: 'Account',
  balance: 'Balance',
  login: 'Login',
  logout: 'Logout',
  register: 'Join',
  select_cancel: 'Uncheck',
  cancel: 'Cancel',
  modify: 'Modify',
  auto_input: '(Automatic input)',
  confirm: 'Confirm',
  look_up: 'Inquiry',
  password: 'Password',
  account_delete: 'Delete',
  detail: 'Details',
  list_detail: 'More Details',
  birth: 'Birth',
  welcome: 'Welcome',
  please_login: 'Please login',
  confirmation_login: 'You can check it when you log in.',
  id: 'ID',
  find_id: 'Forgot your ID',
  find_password: 'Forgot your password',
  back: 'Back',
  agreement: 'Terms of agreement',
  info_input: 'Input information',
  success: 'Complete',
  agree_msg: 'I agree.',
  all_agree: 'I agree to all',
  agree: 'Agree',
  agreed: 'Agreed',
  confirm_password: 'Confirm Password',
  repeat_password: 'Confirm Password',
  next: 'Next',
  before: 'Go Back',
  register_success: 'Sign Up now.',
  verify: 'Confirm',
  retention: 'Possesion',
  allow: '(permit)',
  disallow: '(Unacceptable)',
  upload_btn: 'Upload_btn',
  continue_entry: 'Please enter "[+:verification]" below to continue',
  login_msg_1: 'Try a coin-related account',
  login_msg_1_1: 'on',
  login_msg_1_2: '@:(brand.name)!',
  login_msg_2: 'Use transaction, wallet and sevices through @:(brand.name).',
  login_msg_3: '@:(brand.name) supports all environments.',
  brand_register: 'Join @:(brand.name)',
  register_msg_1:
    '<strong>Join as Member.</strong> <br /> Please agree to our terms and conditions',
  register_msg_3:
    'A @:(brand.name) account will give access <br /> for all services at ease.',
  register_msg_all:
    'Consent to all includes consent to required and optional items, and you can select consent individually. Even if you refuse to agree to the options, the service is available.',
  register_title: 'I am above the age of 19 and older.',
  register_title_2: '@:(brand.name) Terms',
  register_title_3: '@:(brand.name) Integrated Terms of Service',
  register_title_4: '@:(brand.name) marketing leverage agreed',
  register_title_5: 'Consent to Collection and Use of Personal Information',
  register_title_6: 'Consent to Collect and Use Location Information',
  register_title_7: 'Agree to collect additional profile information',
  register_title_8: 'Input @:(brand.name) Account Information',
  register_title_9: 'Input Information',
  register_msg_4:
    'These terms apply to all the services provided by the company. <br /> By agreeing to these terms, you can use these services without signing a separate contract.',
  required: '[Required]',
  option: '[Selective]',
  otp_notice: 'The state is activated and deactivated OTP impossible.',
  required_check: 'Please check all required fields',
  check_input: 'Please enter all the details.',
  register_guide: 'How to Use @:(brand.name)',
  register_step1: 'Click @:(brand.name) Button',
  register_step2: 'Login to @:(brand.name)',
  register_step3: 'Pay/Recharge @:(brand.name) Log In',
  copy: 'Copy',
  no_account: 'There is no registered accounts.',
  inviter_link: 'Referral links',
  register_used_account: 'Register frequently used accounts',
  security_certification: 'Security Certification',
  admin_security: 'The security level for {action} is {limit}.',
  company: 'Business',
  exact_calculation: 'Exact calculation',
  profile: 'Profile',
  inquiry: 'Inquiry',
  announcement: 'Announcement',
  information: 'Information',
  history: 'History',
  registration_date: 'Registration date',
  pay: 'payment',
  detail_search: 'Detailed search',
  more_view: 'See more',
  exchange_store: 'Exchange',
  external_transaction: 'External transaction',
  favorites: 'Favorites',
  no_favorite_list: 'There are no favorites.',
  no_alias: 'No alias',
  please_enter_account_name: 'Please enter your account name.',
  variable_amount: 'Variable amount',
  changes: 'Changes',
  account_transaction_history_inquiry: 'Account transaction history inquiry',
  exchange_application_completed:
    'The application for currency exchange has been completed.',
  choose_how_pay_fee: 'Choose how to pay the fee',
  free: 'free',
  closing: 'closing',
  relative_asset_inquiry: 'Relative asset inquiry',
  please_enter_relative_account_number:
    'Please enter the relative account number.',
  Please_enter_relative_wallet_address:
    'Please enter the relative wallet address.',
  memo: 'Memo',
  write_history_memo: 'It is convenient to manage when you write down a memo.',
  re_enter: 'Re-enter',
  transfer_wallet_account: 'Transfer wallet address',
  transfer_wallet_inquiry: 'Transfer wallet inquiry',
  Kiosk: 'Kiosk',
  withdrawable_amount: 'Withdrawable amount',
  transferred_assets: 'Transfer assets',
  recipient: 'Recipient',
  recipient_wallet: 'Recipient wallet',
  register_user_name_tit:
    'We recommend that you fill in the real name for security certification.',
  register_password_tit:
    'Please fill out the frequently used email address correctly.',
  product_name: 'Products',
  dividend_type: 'Dividend product',
  auto: 'Automatic',
  manual: 'Manual',
  s_usdt_protocol: 'Tether Protocol',
  ccf: {
    what_ccf: 'What is USOT?',
    key_coin:
      'It’s key coin of @:(brand.name) which connects cryptocurrency to real currency',
    ccf_description:
      "It's the key coin of @:(brand.name) which is converted through various cryptocurrency in Direct exchange and C2C transactions. A USOT is worth a cent of USD. USOT enables quicker and safer purchases and transactions at @:(brand.name).",
    how_use_ccf: 'How to use USOT?',
    brand_wallet_transfer:
      'Transfer cryptocurrency assets from other exchanges to @:(brand.name) Wallet.',
    ccf_conversion:
      'Convert the transferred cryptocurrency to USOT through Direct exchange and C2C transactions.',
    direct_exchange_c2c_deal: 'Direct exchange and C2C transaction',
    ccf_moved: 'The converted USOT transferred to @:(brand.name) Account',
    how_use_account_ccf: 'Use the USOT transferred to your account like this!',
    freely_purchase_open_market:
      'Use the USOT to buy products at the open market freely!',
    free_deposit_withdrawal:
      'You can transfer cryptocurrency assets, deposit and withdrawal between accounts in the bank!',
    exchange_currencies_convenient:
      'It’s more convenient to exchange cryptocurrency through the Direct exchange and C2C transaction',
    offline_convenient:
      'Use @:(brand.name)’s services conveniently even offline!',
    how_wallets_accounts_different:
      "What's the difference between Wallet and Account?",
    same_means_storing_cryptocurrency:
      'Wallet and Account is the same meaning to keep cryptocurrency in @:(brand.name). Namely, use Wallet to transact between exchanges and @:(brand.name)(external), use Account to transact in @:(brand.name)(internal).',
  },

  header: {
    certification_management: 'Certification/Management',
    c2c_enroll: 'Purchase / Sale Registration',
    wallet_list: 'Purse / History Lookup',
    wallet: 'Wallet',
    c2c_list: 'Purchase / Sales history',
    no_c2c_sell_list: 'There is no sales history.',
    transfer_list: 'Currency change',
    no_transfer_list: 'There is no exchange history.',
    withdrawal_list: 'Deposits / Withdrawals',
    my_info: 'My Info',
    home: 'Main',
    payment_history: 'Payment history',
    account_transfer: 'Account transfer',
    transfer_history: 'Transfer history',
    register_used_account: 'Register frequently used accounts',
    exchange: 'Currency exchange',
    exchange_list: 'Currency exchange history',
    email: 'e-mail',
    email_list: 'Email history',
    otp: 'OTP',
    otp_list: 'OTP History',
    register_account: 'Register account',
    calculation_account_list: 'List of settlement accounts',
    security_certification: 'Security Certification',
    exact_calculation: 'Exact calculation',
    history: 'History',
    information: 'Information',
    my_profile: 'My profile',
    email_modify: 'Edit email',
    password_modify: 'Edit your password',
    inquiry: 'Inquiry',
    inquiry_history: 'Inquiry details',
    one_on_one_inquiry: '1:1 Inquiry',
    frequently_asked_questions: 'FAQ',
    announcement: 'Announcement',
    notice: 'Notice',
    server_notice: 'Server notice',
    service_center: 'Service center',
    profile: 'Profile',
    company: 'Company',
    account_management: 'Account management',
    do_exchange: 'Currency exchange',
    transfer: 'Transfer',
    look_up: 'Lookup',
    faq: 'FAQ',
    server: 'Server',
    email_request: 'Email Request',
    Product_Subscription: 'Product & Subscription',
    easy_payment: 'Easy payment',
    easy_login: 'Easy login',

    product_subscription_list: 'Product Account Inquiry',
    product_return_list: 'Check refund history',
    product_dividend_list: 'Dividend receipt details inquiry',
  },
  footer: {
    footer_msg: 'Try a coin-related account on @:(brand.name)!',
    footer_sub_msg:
      'Use transaction, wallet and sevices through @:(brand.name).',
    footer_sub_msg2: 'Tip',
    footer_sub_msg3: '@:(brand.name) supports all environments',
    ICO: 'ICO',
    c2c: 'P2P exchange',
    b2c: 'Spot Trading',
    margin_exchange: 'Binary exchange',
    gift_exchange: 'Gift exchange',
    Binary: 'Binary options',
    integrated_exchange: 'Integrated exchange',
    open_marcket: 'Open market',
    game: 'Game',
    proceed: 'Transaction in progress',
    public: 'Go Public',
    direct_ex: 'Direct exchange',
    buy: 'Buy',
    sell: 'Sell',
    buy_sell: 'Buy / sell',
    holding_coin: 'Holding coin',
    fee: 'Fee information',
    exchange: 'Exchange',
    transfer_record: 'Transaction record',
    Leverage: 'Leverage',
    live_exchange: 'Live deal',
    demo_exchange: 'Demo deal',
    contest: 'Contest',
    powerball: 'Powerball',
    law:
      "Legal: @.upper:(brand.domain)'s registration number: 70638826927 (U 6 29 Railway Pde EastwoodNSW 2122)",
    law1:
      'Trading Point of Financial Instruments The owner of the entire Ltd (Australia) is @:(brand.legalName) Registration number: 70638826927 trademark.',
    law2:
      'This Web site is powered by @:(brand.legalName). @:(brand.legalName) approved number 64,190 - are under the regulation of the Auxiliary finance service, it is registered in the reference number 70638826927 Australia.',
    law3:
      '@:(brand.name) operates according to the Australian financial products investment guidelines.',
    law4:
      'Ref. no. 538324 | ABN reg. 70638826927 | BA reg. 64190. To make sure that you are allowed to use @:(brand.name) services in the legal provisions of the country of residence is the sole responsibility of the customer.',
    law5: 'Please read the Risk Disclosure professional @:(brand.name).',
    law6:
      '@:(brand.name) does not provide services to the United States, Belize, Mauritius, Japan, Alberta, British Columbia, Quebec, Saskatchewan Residents of Saskatchewan, Haiti, Suriname, North Korea, Puerto Rico and the occupied area of ​​Cyprus.',
    law7:
      'Please refer to the regulatory part of the FAQ for more information. Please refer to our Risk Disclosure.',
    law8:
      'Restricted areas: Trading Point of Financial Instruments Ltd does not provide investment and ancillary services to third world countries and regions.',
    law_warn: 'Risk Warning:',
    law_1:
      'CFD has a high risk and complex products quickly lose their money due to leverage. 69.10% of individual investors account it will lose money when trading the CFD.',
    law_2:
      'You must consider whether you can accept the fact that you understand the CFD works, the higher the risk of losing money. Please refer to our Risk Disclosure.',
    alert_title: 'Note and Note',
    market: '@:(brand.group) Market',
    ieo_market: 'IEO Market',
    news: 'News',
    event: 'Event',
    platform_rental_title: 'Platform Rental',
    education: 'education',
    online_Academy: 'Online Academy',
    offline_Academy: 'Offline Academy',
    shopping_basket: 'shopping basket ',
    best_product: 'Best Deals',
    order: 'order',
    my_page_title: 'My page',
    member_info_management: 'Account Management',
    order_management: 'Order Management',
    my_question: 'my question',
    one_enquiry: '1:01 Contact',
    community: 'community',
    lotto: 'Powerball Lottery',
    rock_event: 'Rock Event',
    quiz_game: 'Trivia Game',
    ladder_game: 'Ladder',
    tetris: 'Tetris',
    split_lotto: 'Divided Lotto',
    day_Lottery: 'Daily lottery',
    attendance: 'attendance check',
    scoop_out: 'Embed',
    forum: 'forum',
  },
  main_msg: {
    about_1_title: '"World"s Best Cryptocurrency Trading Service',
    about_1_msg: '@:(brand.name) leads all services related to coins.',
    about_1_1_msg:
      'You can buy and sell cryptocurrency coins in one place for the first time in the world."',
    about_1_2_msg:
      'As for the direct exchange it is available at @:(brand.name).',
    about_2_title: 'Instant exchange system',
    about_2_msg:
      '@:(brand.name) uses stable multiple parallel matching technology Advanced design technology to enable instant exchange I have a currency exchange system',
    about_3_title: 'Create Wallet',
    about_3_msg:
      '@:(brand.name) is composed of the best security experts in Korea. Provides a state-of-the-art security system and a WALLET system',
    about_4_title: 'Easy Trading System (C2C)',
    about_4_msg:
      '@:(brand.name) builds a user-friendly easy trading system Let`s make transactions easier.',
    c2c_main_msg1_1:
      '@:(brand.name) will immediately exchange using reliable multi-parallel matching technology',
    c2c_main_msg1_2:
      'Hold the exchange system, applying the advanced design techniques to enable and',
    c2c_main_msg1_3: 'There is.',
    c2c_main_msg2_1:
      'Security experts have been @:(brand.name) is composed of the best engineers in Korea',
    c2c_main_msg2_2:
      'Equipped with state-of-the-art security system provides Wallet system.',
    c2c_main_msg3_1:
      '@:(brand.name) is more easy to build user-friendly trading system',
    c2c_main_msg3_2: 'It allows for easy trading.',
  },
  toasted_msg: {
    agree_required_term: 'Please agree to the required terms and conditions',
    must_read_term:
      'You must read or download all of the terms and conditions.',
    confirm: 'Confirmed',
    changed: 'Changed',
    withdrawal: 'Deactivated',
    register: 'Registered',
    delete: 'It has been deleted.',
    title: 'Notifications',
    exchange: 'Direct currency was successfully processed.',
    search: 'Viewed',
    deposit_request: 'Your deposit request',
    withdraw_request: 'Withdrawal requested',
    create_account: 'Opened',
    modify: 'Modified',
    cancel: 'Canceled',
    trade_confirm: 'The transaction has been confirmed.',
    trade_reject: 'Trade declined.',
    copy: 'Copied',
    nice_msg:
      'If your browser settings don`t allow pop-ups, authentication won`t proceed normally.',
    nice_title: 'Guide',
    nice_success: 'Your authentication was successful.',
    nice_error: 'I can`t authenticate myself',
    no_transfer: 'I can`t authenticate myself',
    email_auth: 'Email authentication completed successfully',
    email_auth_send: 'An authentication email has been sent',
    kyc_withdraw: 'Account verification succeeded',
    not_allow_trade: 'Trade inactive',
    id_find_mail_send: 'Your email has been sent.',
    duplicate_check: 'Duplicate ID or email.',
    pay: 'Payment is complete.',
  },
  private: {
    deal_list: 'Sales History',
    app_list: 'Purchase History',
    deal_buy_asset: 'Assets to buy',
    buy_price: 'Purchase price',
    confirmed_source_amount: 'Confirmed sales quantity',
    holding_source_amount: 'Uncommitted sales quantity',
    potential_source_amount: 'Available quantity',
    direct_market: 'Direct exchange',
    deal_enroll: 'Sales registration',
    app_enroll: 'Purchase registration',
    select_market: 'Market select',
    fee_rate: 'Fee rate',
    deal_info_input: 'Enter sales info',
    deal_source_amount: 'Sales quantity',
    deal_price: 'Sell price per piece',
    deal_enroll_account: 'Account for Sale Registration',
    account_select: 'Select account',
    direct_asset_select: 'Select assets to sell and buy',
    please_select_asset: 'Please select an asset',
    basic_rate: 'Current price',
    direct_transfer_buy: 'On purchase immediately',
    direct_transfer_sell: 'On sale immediatel',
    direct_source_amount: 'Quantity of exchange',
    direct_target_amount: 'Applied quantity',
    direct_asset_buy: 'Buy with {0}',
    direct_asset_sell: 'Sell as {0}',
    selected_deal_info: 'Selected sales info',
    deal_source_asset_title: 'Purchase asset',
    deal_total_source_amount: 'Total Sales Quantity',
    app_info_input: 'Enter purchase info',
    app_amount: 'Purchase quantity',
    app_deal_price: 'Price per unit',
    pay_target_amount: 'Quantity to pay',
    fee: 'Fee',
    fee_calc: 'Fee amount',
    msg_fee_calc: 'Deducted by {0}',
    app_account: 'Account for Purchase Registration',
    app_receive_account: 'Choose account to receive',
    c2c_buy_select_asset: 'Please select an asset to buy',
    go_home: 'Go back to main',
    buy_calc_spread: ' Buying rate',
    sell_calc_spread: 'Selling rate',
    cs_market_asset: 'Asset pair',
    cs_market_basic_rate: 'Basic rate of deal',
    transfer_type: 'Exchange type',
    exchange_rate: 'Applied exchange rate',
    submit_transfer: 'Exchange',
    deal_source_min_amount: 'Minimum Purchase Quantity',
    closed_date: 'Closed date',
    no_deal: 'No sales list',
    app_price_per_quantity: 'Price per quantity',
    app_fee_amount: 'Sum total',
    select_deal_app_list: 'Purchases for selected sales',
    no_select_deal_app_list: 'No purchase history for this sale',
    transfer_source_amount: 'Reference asset quantity',
    transfer_target_amount: 'Relative asset quantity',
    transfer_basic_rate: 'Applied rate',
    transfer_spread_rate: 'Applied spread rate',
    transfer_exchange_rate: 'Applied exchange rate',
    transfer_list_detail: 'Cryptocurrency exchange details',
    transfer_source_asset: 'Reference assets',
    transfer_target_asset: 'Relative assets',
    transfer_source_account_number: 'Reference asset account number',
    transfer_target_account_number: 'Relative Asset Account Number',
    transfer_detail_type: 'Exchange',
    transfer_regdate: 'Requested date and time',
    transfer_asset_info: 'Reference asset',
    transfer_asset_select: 'Select the asset exchange',
    msg_transfer_buy: 'Buy with {0}',
    msg_transfer_sell: 'Sell as {0}',
    deal_fee_amount: 'Sale Disclosure party imposed fees',
  },
  wallet_page: {
    have_asset: 'Holding assets',
    asset_list: 'Asset list',
    account_list: 'Account list',
    account_create: 'Create account',
    deposit: 'Deposit',
    withdraw: 'Withdrawal',
    deposit_list_look: 'View deposit result',
    deposit_look: 'Deposit lookup',
    withdraw_list_look: 'View withdrawal result',
    withdraw_look: 'Withdrawal lookup',
    account_modify: 'Edit account',
    deposit_apply: 'Apply for deposit',
    withdraw_apply: 'Withdrawal',
    deposit_request_amount: 'The deposit amount',
    withdraw_request_amount: 'Withdrawal amount',
    withdraw_account_info: 'Withdrawal account information',
    holder_name: 'The name of the holder',
    bank_name: 'Bank name',
    withdraw_bank_address: 'Account number',
    withdraw_address: 'Asset address (Wallet Address)',
    qr_address: 'Account address',
    create_qr_address: 'Open Account Address',
    account_enroll: 'Account Registration',
    account_seq: 'Account unique number',
    account_title: 'Account name',
    regdate: 'Opening date',
    before_regdate: '(before opening)',
    holding_balance: 'Hold amount',
    select_asset: 'Select asset',
    create: 'Open',
    deposit_list: 'Deposit History',
    no_deposit_list: 'There are no deposit application details.',
    deposit_apply_detail: 'Requested Deposit Details',
    asset_title: 'Asset name',
    request_amount: 'Request amount',
    withdraw_list: 'Withdrawal history',
    no_withdraw_list: 'There is no withdrawal request.',
    withdraw_apply_detail: 'Requested Withdrawal Details',
    withdraw_fee_total_amount: 'Total withdrawal (including fees)',
    net_amount: 'Final amount',
    fee_type: 'Fee type',
    fee_charge_type: 'Fee charge type',
    amount_of_fee: 'Amount of fee',
    create_account_address: 'Account Opening Address',
    deposit_msg: 'Deposit my wallet {0} {0} from the outside of the wallet.',
    deposit_msg_1:
      'Once approved 350 times (confirmation) on the block chain {0} transactions are reflected in the wallet.',
    deposit_step_1: 'STEP 1. Check the ID {0} memos first.',
    deposit_step_1_1: 'My notes ID {0}',
    deposit_step_1_2:
      '{0} must mark your own notes ID when you deposit. {0}, with no transfer notes ID is lost.',
    deposit_step_1_3: 'View your {0} Wallet address.',
    deposit_step_1_btn: 'Notes ID Copy',
    deposit_step_2: 'STEP 2. Check your wallet address.',
    deposit_step_2_1: 'QR code',
    deposit_step_2_2: 'Wallet Address',
    deposit_step_2_3:
      'The minimum deposit amount is <span style = "color: # 4a90e2"> {0} {1} is </ span>.',
    deposit_step_2_btn: 'Purse Copy Address',
    deposit_msg_2: 'Please check',
    deposit_msg_2_1: 'This address is the address for deposit only.',
    deposit_msg_2_2:
      'The total time it takes to conform completion may be affected by the congestion of the block chain network, cryptocurrency stars Block Chaining congestion is <span style = "color: #4a90e2; cursor: pointer;"> here </span> you can check.',
    no_account_list: 'There is no account list.',
    no_favorite_account_list: 'There is no favorite account list.',
    input_account: 'Please enter your account name to change.',

    product_subscription_list: 'Product Account Inquiry',
    product_account_list: 'Product Account List',
  },
  my_page: {
    profile: 'Member information',
    user_unique_num: 'Member identification number',
    user_name: 'User name',
    email_address: 'Email',
    register_regdate: 'Subscription date',
    last_login: 'Last login',
    auth_complete: 'Authentication completed',
    not_auth: 'Uncertified',
    expdate: 'Expiration date',
    act_auth: 'Authenticate',
    realname_auth: 'Person authentication',
    email_auth: 'Email authentication',
    otp_auth: 'OTP authentication',
    enroll: 'Enroll',
    security: 'Security level',
    show_security: 'Show level',
    auth_withdraw_address: 'Withdrawal address authentication',
    apply_list: 'Application history',
    password_modify: 'Modify password',
    email_modify: 'Modify email',
    account_block: 'Delete Account',
    placeholder_old_password: 'Please enter your existing password',
    placeholder_new_password: 'Please enter a new password',
    placeholder_confirm: 'Please enter one more time',
    placeholder_password: 'Please enter your password',
    placeholder_email: 'Please enter a new email',
    mail_cert_list: 'Email application History',
    no_mail_list: 'No email application history.',
    nominee_detail: 'Recommendee history',
  },
  kyc: {
    register_account: 'Register account',
    kyc_enroll: 'Apply for KYC Certification',
    kyc_enroll_2: 'KYC proof of address',
    kyc_enroll_3: 'KYC Reason for 4 step upward adjustment',
    auth: 'Authentication',
    auth_code_send: 'Send verification code',
    auth_confirm_code: 'Confirm Code',
    auth_code: 'Authentication code',
    msg_auth_code: 'Please enter your verification code within 5 minutes',
    type_title: 'Type name',
    withdraw_auth: 'Authenticate withdrawal address',
    withdraw_auth_tit:
      'An objective address authentication procedure for external deduction.<br /> Please register the target account and wallet address to be purchased.',
    withdraw_auth_tit_m:
      'An objective address authentication procedure for external deduction. Please register the target account and wallet address to be purchased.',
    select_asset: 'Select assets',
    select_bank: 'Select bank',
    holder_name: 'The name of the holder',
    birth: '6 digits of birth',
    address: 'Asset address',
    withdraw_list: 'Withdrawal account application',
    bank_name: 'Bank name',
    withdraw_info: 'Withdrawal account information',
    withdraw_complete: 'The asset is already verified',
    regdate: 'Registration date',
    delete_withdraw_address: 'Changed debit address',
    delete_success_address: 'The withdrawal address has changed.',
    kyc_cert_list: 'KYC Application History',
    no_kyc_list: 'KYC is no application history.',
    no_kyc_withdraw_address_list:
      'There is no payment account application history.',
    kyc_placeholder: 'Please enter.',
  },
  otp: {
    enter_verification_number: '*Enter your OTP verification number',
    otp_auth: 'OTP authentication',
    authenticode: 'OTP key',
    otp_deactivate: 'OTP deactivate',
    msg_authenticator_installation:
      'Please install the" Google Authenticator "app on your smartphone or desktop',
    android: 'Android ',
    or: 'or ',
    iphone_series: 'IPhone, iPad, and iPod',
    windows_phone: ' Windows Phone',
    and: 'And',
    msg_microsoft_other_systems: 'Microsoft Windows desktop',
    msg_key: 'Please write down the key',
    msg_use_loss_change:
      'When you lose your device or need to change your OTP use this key.',
    msg_brcode_touch:
      'Open the "Google Authenticator" app and tap Scan QR barcode at the bottom of the screen.',
    msg_input_authenticode:
      'Please enter the verification code displayed on your device screen in the "Authorization Code" below.',
    otp_key: 'OTP key',
    otp_activate: 'OTP activate',
    otp_copy: 'OTP key copied',
    otp_safe_keeping:
      'Did you write the OTP key on paper and store it in a safe place?',
    yes: 'Yes',
    otp_register: 'Register',
    otp_register_success: 'OTP registration completed successfully.',
    otp_delete_success: 'OTP Erase Registration completed successfully.',
    msg_click_key_copy: 'Click to copy the key',
    otp_login: 'OTP login',
  },
  security: {
    show_security: 'Show security level',
    grade: 'Grade',
    condition: 'Condition',
    restriction: 'Restriction',
    no_grade: 'Unrated',
    no: 'None',
    security_title: 'Constraints by Condition of Security',
    banner1: 'Trusted Security',
    banner2:
      'For the purchase or sale through @:(brand.name), @:(brand.name) must secure data encryption, real-time transaction monitoring, the buyer and seller protection policy, and all your payments through a secure checkout and payment scheme received @:(brand.name).',
    banner_invite: '@:(brand.name) Do not have an account?',
    banner_join: 'Free Sign Up',
    banner3: 'How @:(brand.name) is keeping our customers safe',
    content1_h3: 'Buyer Protection',
    content1_text:
      'If the buyer ohbaesong wear or damage mibaesong, @:(brand.name) can compensate for the total payment amount, including shipping costs for eligible transactions. *',
    content2_h3: 'Seller Protection',
    content2_text:
      'If you receive an unauthorized payment or mibaesong claims against the seller in the sale are eligible, you can get the full amount of protection. *',
    content3_h3: 'Data Encryption',
    content3_text:
      'TLS, HTTPS connections to help keep the payment, the key pinning of mobile apps, PCI compliance more secure.',
    content3_btn: 'PCI Compliance',
    content4_h3: 'Fraud Prevention',
    content4_text:
      'All transactions are monitored in real time by analyzing your account and support to prevent fraudulent activity and billing.',
    sec_h2: 'Check Buy',
    sec_text:
      '@:(brand.name) because the transaction monitoring 24 hours a day, 365 days when it detects something different from usual to contact the buyer asks you to confirm your login or purchase. Also @:(brand.name) checks for all purchases and sales via e-mail.',
    wran_h2: 'If you find a suspicious points',
    warn_step1: 'Report.',
    warn_step1_text1:
      'After you confirm the details have not found a deal approved',
    warn_step1_text2: 'Report a problem> unauthorized activity report',
    warn_step1_text3: 'Click or contact immediately @:(brand.name).',
    warn_step2: 'Check if there are other problems.',
    warn_step2_text1:
      'Review recent trading activity and account settings to make sure that the additional charges or changes, please also report this information.',
    warn_step3: 'Please change your password.',
    warn_step3_text1:
      "You can in the account settings on the Security menu. Or, if you're unable to sign in to your account",
    warn_step3_text2: 'Login> Problems logging',
    warn_step3_text3: 'Click to get reset.',
    warn_btn: 'Report unauthorized transactions',
    online_h2: '@:(brand.name) supports Secure online activities.',
    online_h3: 'Account Security',
    online_text: 'Protect your account with a highly secure password.',
    online_btn: 'Learn more',
    auth_incomplete: 'Certified incomplete',
  },
  input: {
    id: 'Input ID',
    password: 'Input a password (8+ chars, 1 uppercase & 1 special)',
    repeat_password: 'Confirm Password',
    user_name: 'Input Username',
    email_address: 'Input E-mail address',
    mismatch_password: 'Passwords do not match.',
    has_min_length: 'Password must be at least 8 characters long.',
    has_special_char: 'Password must include at least one special character.',
    has_uppercase: 'Password must include at least one uppercase letter.',
  },
  oauth: {
    contact_msg:
      'Wants access to the following information in the application {0}.',
    agree_msg: '{0} Do you agree that access to {1} `s personal information?',
    agree_info:
      'The information provided will be utilized / stored for a period of service for the user identification, statistics, accounts linked CS and the like. Basic information and provide the required items is the information that must be provided to use the @:(brand.name) services.',
    agree_request: 'Offerings',
    agree_msg2:
      'Once agreed, the information will be managed in accordance with the Terms and Conditions and Privacy Policy of the service.',
    agree: 'To agree',
  },
  pay_head_foot: {
    account_management: 'Account management',
    settlement_account_list: 'Settlement Account List',
    account_summary_views: 'Account Summary Views',
    fund: 'funds',
    history: 'Payment history',
    help: 'Help',
    qa: 'Contact Us',
    fee: 'fees',
    secure: 'security',
    go_shop: 'Shopping',
    my_info: 'My profile',
    my_page: 'Account Settings',
    out: 'Log out',
    in: 'Login',
    about: 'About Us',
    blog: 'blog',
    employ: 'Jobs',
    site_map: 'Site map',
    developer: 'developer',
    partner: 'partner',
    privacy_state: 'Privacy Statement',
    usage: 'Terms of Use',
    feed_back: 'feedback',
    warn_to_consumer:
      'Notification to customers: the owners of prepaid means of payment @:(brand.name) ⓒ @:(brand.name) does not require the approval of the Australian Financial Supervisory Authority. Please read carefully the terms and conditions.',
  },
  continue: 'continue',
  pay_home: {
    brand_title: '@:(brand.name)',
    platform: 'platform',
    platform_rental: 'Renting platforms',
    help: 'Helping.',
    home_banner_1:
      'Expanding the potential customer base around the world, and to facilitate payment management,',
    home_banner_2:
      'Business Seller Protection *, and allow safe to shop with 24/7 fraud monitoring.',
    home_banner_3: 'You can more easily succeed.',
    home_banner_warn:
      '* Terms and Conditions apply to the protection seller. Please refer to your contract for details on eligibility.',
    home_banner_join: 'Join now for free.',
    home_sec1_openShop: 'You can open a store in @:(brand.name).',
    home_sec1_btn: 'To deal',
    home_sec2_h2_01: 'Get the payment the',
    home_sec2_h2_02: 'way you want.',
    home_sec2_text1:
      '@:(brand.name) receives payments online, mobile and even e-mail.',
    home_sec2_text2: 'Whether you sell it to anyone and anywhere, ',
    home_sec2_text3: '@:(brand.name) helps you make easier and safer payments.',
    home_sec2_online_pay: 'Online',
    home_sec2_online_text:
      "@:(brand.name)'s easy-to-set payment button is  very convenient for payment, regular payment, donations, etc. @:(brand.name) Checkout makes it easier and faster for customers to pay.",
    home_sec2_online_more: 'See more online payment',
    home_sec2_voice_invoice: 'Email Invoice',
    home_sec2_voice_text:
      "Easy e-mail payment with a professional free invoice. Overseas customers are also available who don't have @:(brand.name) account.",
    home_sec2_voice_more: 'See more about email invoices',
    home_sec2_exchange_pay: 'Exchange',
    home_sec2_exchange_text:
      "With the integrated wallet service on the exchange, you can recharge and buy and sell coins on any partener's exchanges.",
    home_sec2_exchange_more: 'Learn more about exchange charging',
    home_sec2_mobile_pay: 'Mobile',
    home_sec2_mobile_text:
      'Solutions are automatically optimized for mobile. Get paid more easily through your mobile website or Android and iOS apps anywhere in the world.',
    home_sec2_mobile_more: 'See more about mobile payments',
    home_sec3_h2: 'Find more work with @:(brand.name) freelance partners.',
    home_sec3_global:
      "@:(brand.name) will connect the more global opportunities with the world's top freelance sites.",
    home_sec3_btn: 'Checking @:(brand.name) for freelance',
    home_sec4_h2: "It's easy to get started.",
    home_sec4_banner1:
      'Learn everything you need to start from @:(brand.name) business hub.',
    home_sec4_banner2:
      'Join the business account and verify your email address',
    home_sec4_banner3: 'Certified to the bank account',
    home_sec4_banner4: 'Select a payment solution',
    home_sec5_h2:
      'Why so many operators around the world trust @:(brand.name)?',
    home_sec5_sub_text:
      'Because it is an excellent choice. @:(brand.name) you like to connect the seller with 25 calls to the customer at least two one hundred million people in more than 200 markets worldwide.',
    home_sec5_sub_text_1:
      "Because it's a great choice. We connect sellers to over 200 million customers in 200+",
    home_sec5_sub_text_2: 'markets around the world in 25 currencies.',
    home_sec5_h3: 'Safety',
    home_sec5_h3_sub1:
      'Automatically determining scam, 24-hour monitoring transactions and the seller and buyer protection program protect your business and your customers.',
    home_sec5_h3_more: 'See more about online payment',
    home_sec5_h31: 'Used in all over the world',
    home_sec5_h31_sub1:
      'Anyone in the world can make a quick payment without entering information every time. Payments can be made via credit card, debit card, or @:(brand.name) in 26 currencies in 203 markets.',
    home_sec5_h31_more: 'See more about email invoices',
    home_sec5_h32: 'Fast',
    home_sec5_h32_sub1:
      'In most cases customer payment is immediately credited to your  @:(brand.name) account. Withdrawing, paying price or use freely in any place where @:(brand.name) payment is possible.',
    home_sec5_h32_more: 'See more about eBay selling',
    home_sec5_btn: 'Member registration',
    home_sec6_h2: 'Simple fee structure',
    home_sec6_sub:
      "@:(brand.name) will charge a fee only when the sales made. @:(brand.name) fees are fixed based on the customer's location and the amount of sales.",
    home_sec6_more: 'See more about fees',
    home_sec7_h2: 'Community for South Korea selling, CBT LAB',
    home_sec7_text1:
      'Cross-Border Trade Institute (CBT LAB) is a @:(brand.name) Korea (@:(brand.name) Korea) merchant community sponsored for overseas e-commerce enabled.',
    home_sec7_text2:
      'CBT LAB is helping the East Coast business grow globally share information such as the latest trends, tips, and best practices.',
    home_sec7_more: 'Learn how to take advantage of CBT LAB',
    home_sec8_h2: 'Meet the partners interlocking @:(brand.name).',
    home_sec8_text1: 'Need professional help for your online business?',
    home_sec8_text2:
      'Web hosting solutions, shopping cart, e-commerce solutions, such as advance works @:(brand.name) a partner bought this help your business.',
    home_sec8_text3: 'Find @:(brand.name) a partner for my business right now.',
    home_sec8_more: 'More Partners',
    home_sec9_h2: 'Become a global seller. This will @:(brand.name) together.',
    home_sec9_h2_1: 'Become a global seller.',
    home_sec9_h2_2: 'This will @:(brand.name) together.',
    home_sec9_btn: 'Sign up for an account now',
    home_learn_h2: 'Learn more',
    home_learn_li1: 'Web Payment Solution',
    home_learn_li1_1: 'Website Payments Standard',
    home_learn_li1_2: '@:(brand.name) Checkout',
    home_learn_li1_3: 'Buy on eBay',
    home_learn_li1_4: 'Compare Solutions',
    home_learn_li2: 'Other payments',
    home_learn_li2_1: '@:(brand.name) email invoices',
    home_learn_li2_2: 'Mobile Commerce',
    home_learn_li2_3: 'Business for automatic payments',
    home_learn_li2_4: '@:(brand.name) for B2B',
    home_learn_li2_5: '@:(brand.name) for freelance',
    home_learn_li3: '@:(brand.name) setup and integration',
    home_learn_li3_1: '@:(brand.name) business hub',
    home_learn_li3_2: '@:(brand.name) Korea merchant community (CBT LAB)',
    home_learn_li3_3: 'Add @:(brand.name) @:(brand.name) to the site',
    home_learn_li3_4: 'Check out Best Guide Set',
    home_learn_li3_5: 'developer',
    home_learn_li3_6: 'partner',
    home_learn_li3_7: 'How @:(brand.name)',
    home_learn_li4: 'Manage My Account',
    home_learn_li4_1: '@:(brand.name) business apps',
    home_learn_li4_2: 'Business Account Settings',
    home_learn_li4_3: 'Seller Protection Program',
    home_learn_li4_4: 'Manage customer complaints',
    home_learn_li4_5: 'Understanding Chargebacks (Chargeback)',
    home_learn_li4_6: 'Understanding account restrictions',
    home_learn_li4_7: 'Fraud Prevention Tips',
    home_learn_li4_8: 'PCI Compliance',
    home_sec_trade_h2_1: 'Check market prices easily and',
    home_sec_trade_h2_2: 'quickly and manage your assets.',
    home_sec_trade_desc: 'If you need help managing your money, we can help.',
    home_sec_trade_btn: 'Find out more',
    home_sec_quick_desc: 'We will introduce you to our fast banking services.',
    home_sec_quick_cont_1: 'Direct currency exchange',
    home_sec_quick_cont_2: 'Price inquiry',
    home_sec_quick_cont_3: 'View all my accounts',
    home_sec_quick_cont_4: 'Account transfer',
    home_sec_quick_cont_5: 'New account',
    home_sec_quick_btn: 'Learn more',
  },
  pay_nav: {
    view_your_account: 'View your account',
    account_summary_views: 'Account summary views',
  },
  pay_login: {
    secure_sub_title: 'Login and Security',
    secure_my_profile: 'My profile',
    secure_update_complete:
      'The environmental profile and settings have been updated.',
    secrue_suggest: 'Whenever you tell us your experience.',
    search: 'Search',
    my_info: 'Privacy',
    update: 'update',
    e_mail: 'e-mail',
    default: 'Basic information',
    call: 'telephone',
    phone: '(cellphone)',
    pay_mobile: 'mobile pay',
    trading: 'Give-and-take',
    password: 'password',
    change: 'change',
    secure_qa: 'Security Question',
    staying: 'Keep me logged in for faster purchases',
    edit: 'edit',
    browse_manage:
      'Manage the selected device and the browser to maintain login state.',
    account_type: 'Account Types',
    account_delete: 'Account Cancellation',
    business: 'business',
    edit_email: 'Edit email address',
    change_email: 'Change Email Address',
    update_email: 'Add your email',
    eamil_url: 'Email Address',
    update_email_url: 'Add your email address',
    error_email: 'Sorry. The default e-mail can not be edited.',
    confirm_new_email: 'Check for new e-mail address',
    change_mail: 'Change email',
    confirm: 'Confirm',
    changing: 'change',
    deleting: 'delete',
    reaming:
      'There are currently two of the email address associated with your account. You can add more to 5 email.',
    qa_1: 'What is the name of the first attended school?',
    qa_2: 'What is the name of first pet?',
    edit_phone: 'Edit an existing phone number',
    korea: 'Republic of Korea',
    explanation:
      'By adding the number, I confirm that you agree to automatically dial and receive pre-recorded calls and text depending on the reason for the authority to add two numbers are described in the Privacy Policy. Standard rates may apply.',
    edit_phone_num: 'Change phone number',
    edit_password: 'Change Password',
    confirm_password: 'Check your current password',
    new_passod: 'New password',
    confirm_password_new: 'New password confirmation',
    secure_question: 'Security Question',
    secure_pick: 'Choice questions',
    secure_answer: 'answer',
    edit_browse:
      'With @:(brand.name) One Touch you can quickly complete the payment without having to log in each time.',
    already_log: 'The logged on the machine.',
    off_all: '@:(brand.name) One Touch off on all your devices',
    support:
      'PayPal is committed to 100% customer satisfaction. If you have a problem with your account',
    support_center: 'Customer Support',
    support_text1: 'Or check the',
    support_text2: 'Please refer to.',
    support_warn:
      'If you cancel your account, you can not cancel your account records will also disappear and reliability levels.',
  },
  help: {
    support_center: 'Support',
    resolution_center: 'Dispute Resolution Center',
    qa_search: 'Search Frequently Asked Questions',
    common_qa: 'General questions',
    common_qa_1:
      "What `Why is an error message is displayed after updating the status of your order via the 'Get Links funds?",
    common_qa_2: 'How do I withdraw funds from Korea @:(brand.name) account?',
    common_qa_3:
      'How do I add a debit or credit card to my account @:(brand.name)?',
    common_qa_4:
      '@:(brand.name) I forgot my account password. How do I reset my password?',
    common_qa_5: 'Can I cancel already sent payment amount @:(brand.name)?',
    common_qa_6: 'How do I receive payments through @:(brand.name)?',
    common_qa_7: 'How do I send the Payment via @:(brand.name)?',
    common_qa_8: 'How do I add a bank account to @:(brand.name) account?',
    common_qa_9:
      'How can I check the bank account associated with my account @:(brand.name)?',
    common_qa_10: 'How do I disable the account @:(brand.name) limit?',
    technical_support: 'Subscribe to technical issues and updates.',
    muliple_help: 'More ways to get help',
    trading_help: 'To solve such problems deal',
    tex_center: 'Tax Center',
    tex_help: 'Find tax forms and other resources',
    need_help: 'Contact Us',
    help_center: 'Contact Customer Support',
    help_to_center: 'Contact Customer Support',
    prepare: 'Coming soon.',
    fast_help:
      'Tell us your problem so that we can more quickly help @:(brand.name).',
    my_search: 'Search for My Problem',
    common_problem: 'Common Problems',
    login_problem: 'Login issues',
    unkown_charge: 'Unauthorized access or unknown claims report',
    send_money: 'Send money',
    get_fund: 'Receiving money',
    withdraw_money: 'Withdraw money',
    pay_cancel: 'Payment or cancel order',
    pay_hold: 'Payment pending or waiting',
    refund: 'refund',
    pre_pament: 'Pre-approved payments',
    negative_balance: 'Negative balance',
    account_qa_1:
      '@:(brand.name) withdraw from my account the state though it shows as "completed" Why is money that does not contain a bank account?',
    account_qa_2:
      'What is the reason for my withdrawal @:(brand.name) is still a "pending" status?',
    account_qa_3: 'Why was my withdrawal pending?',
    item_title: 'Access Password and Account',
    item_title_2: 'Account Profile & Settings',
  },
  business: {
    no_trade: 'There is no possible exchange markets.',
    view_your_account: 'Inquire full accunt',
    available: 'Available',
    calculate_late: 'We show the most important USOT current assets.',
    payment_transfe: 'Payment transfers',
    exchange: 'exchange',
    currency_update: 'Add call',
    update_btn: 'Plus button',
    currency_cal: 'Currency converter',
    pay_default: 'Payment Preferences',
    payment_send: 'Send or request Payment',
    account_list: 'Account List',
    no_alias: 'No aliases',
    new_bank: 'Connect the new bank',
    card: 'Card',
    new_card: 'Connect the new card',
    credit: 'credit',
    preference_payment: 'Choose your preferred online payment methods.',
    payment_tip:
      'When shopping online or sending Payment for goods and services using this means. You may at any time choose a different payment method during checkout.',
    payment_more: 'Learn about your payment preferences',
    paymnet_changes: '@:(brand.name) balance',
    debit_card: 'Debit Card',
    currency_tip:
      'If you add a currency, all future payments received in that currency will be credited to the appropriate funds. The base currency is used to send a payment or request payment.',
    currency_1: 'Australian Dollar',
    currency_2: 'Swiss Franc',
    currency_3: 'Czech Koruna',
    currency_4: 'Danish Krone',
    currency_5: 'Euro',
    currency_6: 'British Pound',
    currency_7: 'Hong Kong Dollar',
    currency_8: 'Forint',
    currency_9: 'Israeli New Shekel',
    currency_10: 'Mexican Peso',
    currency_11: 'Norway Krone',
    currency_12: 'New Zealand dollar',
    currency_13: 'Philippine Peso',
    currency_14: 'Polish Zloty',
    currency_15: 'Russian Ruble',
    currency_16: 'Swedish Krona',
    currency_17: 'Singapore Dollar',
    currency_18: 'Baht',
    currency_19: 'New Taiwan Dollars',
    withdraw_account: 'Withdrawal Account',
    exchanged: 'After currency exchange',
    exchange_rate: 'Exchange Rate',
    exchange_tip:
      'The exchange rate is an estimated amount based on the current exchange rate, the exchange fee is included in the @:(brand.name).',
    currency_default: '(A) The Japanese Yen is set to the default currency.',
    currency_default_notice:
      'The base currency is used to send a payment or request payment.',
    currency_default_notice2:
      'Closing the call is not displayed on the balance does not receive any payment to the call.',
    currency_default2: 'JPY (s), the default',
    currency_quit_jp_btn: 'Close Dollars',
    currency_quit_btn: 'Close call',
    bank_account: 'account',
    bank_account_create_day: 'Gaeseolil',
    bank_account_change: 'balance',
    bank_account_check: 'Confirming Bank',
    bank_account_remove: 'Delete Bank',
    bank_continue: 'Would you like to continue?',
    bank_tip:
      'Pending transactions with the banks are processed after deletion.',
    bank_this_delete: 'Delete Bank',
    card_tip:
      'The @:(brand.name) account Want to use it without spending or withdrawal limits?',
    card_confirm: 'Check the card.',
    card_type: 'type',
    expiry_date: 'Expiration',
    card_adress: 'Billing Address',
    card_update: 'Card Update',
    card_delete: 'Delete card',
    card_this_delete: 'Delete card',
    card_tip2:
      'This payment method is currently preferred. Upon completion, you can set a different preferred payment method. Deal is pending with (a) undefined is treated after the deletion.',
    secure_code: 'Security Code',
  },
  shop: {
    shop_list: 'Store List',
    shop_create: 'Create store',
    shop_cre_date: 'Added',
    shop_title: 'Store name',
    shop_id: 'Store ID',
    shop_state: 'State',
    shop_work: 'Work',
    shop_detail: 'Detail',
    shop_retouch: 'Modify',
    shop_settlement: 'Accounts list',
    shop_history: 'Transactions',
    no_shop_list: 'There is no list of stores',
  },
  merchant: {
    create: 'Shop registration',
    update: 'registration',
    retouch: 'Shops modified',
  },
  pay_legal: {
    service_usage: '@:(brand.name) Terms of Service',
    detail_usage:
      'These Terms and Conditions will apply to the Asia-Pacific, Latin America and some European countries, Middle East and African users. To view the terms and conditions for different countries or regions, choose from the list below.',
    nation: 'Select a Country',
    every_consumer: 'All users',
    service_agree: 'Your contract for the Service @:(brand.name)',
    privacy_state: 'Privacy Statement',
    purpose_policy: '@:(brand.name) Use Policy',
    payment_agreement: '@:(brand.name) alternative payment method agreement',
    sell_buy: 'Merchant and Business',
    shop_policy: '@:(brand.name) Support Store Policies',
    contract_profit: 'Contract for-profit corporation',
    billing_agreement: 'Billing Agreement',
    direct_debit_agreement:
      '@:(brand.name) funds received and debit agreements',
    additional_info: 'Additional Information',
    infringement: 'Somyeongseo policy violations',
    policy_update: 'Policy Updates',
    warn1:
      'Notify Consumers: @:(brand.name) payment service is regarded as a prepaid means of payment (Stored Value Facility) in accordance with Australian law.',
    warn2:
      '@:(brand.name) the owners of prepaid means of payment ⓒ @:(brand.name) does not require the approval of the Australian Financial Supervisory Authority. We also encourage consumers (users) are carefully read these Terms and Conditions.',
    warn3:
      'These Terms of Use and Notices provide the terms and conditions associated with a particular @:(brand.name) services.',
  },
  pay_privacy: {
    effective_day: 'Effective Date: 28 March 2019',
    summary: 'summary',
    personal_data: 'Personal data collected by @:(brand.name)',
    personal_date_cause: 'Reasons to keep your personal data @:(brand.name)',
    summary_1: 'Our users are',
    summary_2: 'site',
    summary_3: 'Or visit',
    summary_4: 'service',
    summary_5: "When using the user's",
    summary_6: 'Personal data',
    summary_7:
      'How to collect and store, manage, and share, explaining that the transfer has prepared this Privacy Policy. This Privacy Policy applies to your personal data when visiting our site or use the service, other @:(brand.name)',
    summary_8: 'user',
    summary_9:
      'It does not apply to websites or online web @:(brand.name) not owned or adjustments, including service site or service.',
    summary2_1:
      '@:(brand.name) can you visit our sites or collect personal information when you use the following types of services.',
    summary2_2: 'Use Up and Information',
    summary2_3:
      'When you sign up an account to use the services of @:(brand.name), to meet the information necessary to collect personal data in order to provide the service requested by the user.',
    summary2_4:
      'Depending on the services selected, you can ask to provide the identification information required to create a user name, mailing address, telephone number, email address, account.',
    summary2_5:
      'Terms you may ask to provide additional personal data, depending on the service.',
    summary3_1: 'Trading experience and information',
    summary3_2:
      'Using the services of @:(brand.name) or if access to the site, for example, buy from the seller, or receipt of money or if processing a payment or send money to friends and family, collect other trading related information, as well as transaction information from @:(brand.name) The. Other trade-related information includes the sending or requesting money, goods or money payment service, the seller, including information about all the payment methods used to complete the transaction information and device information, technology data, location information, and the like.',
    summary4_1: 'Participant Information',
    summary4_2:
      'When you use or access the site @:(brand.name) service collects personal data that users provide about other participants involved in the deal.',
    summary4_3: 'To send or request money',
    summary4_4:
      'If you send or request money through the Service @:(brand.name) collect your name, mailing address, telephone number, personal data such as receive money from your financial account information of the participant sending the money to you.',
    summary4_5:
      'The scope of personal data requested in relation to the participants may vary depending on the service used to send or request money.',
    summary5_1:
      'Payment for other people instead of bills or bill requesting payment to another person',
    summary5_2:
      'If you use @:(brand.name) service to ask them to pay the bill on behalf of another person, or pay your bills on their behalf to another user, the user name, mailing address, telephone number, email address, user billing instead of bills or others the account owner must collect relevant personal data, including account number you want to pay instead.',
    summary6_1: 'Add money to your account',
    summary6_1_1: 'Your account',
    summary6_2:
      "In order to add money to other accounts in the user's account or the user may own, or if you use @:(brand.name) service to request to be added to the amount in this account to the other users on the other side from the user to efficiently process your request gather information or may collect information about you from the other side.",
    summary6_3:
      'For example, charging or using the services @:(brand.name) request to be added to the amount in the account to a mobile phone, you can collect other information, including personal data, and mobile account number from the other participants.',
    summary7_1:
      'Information relating to the person on your friends and contacts',
    summary7_2:
      "When the user connects the contact list in your account, it's easier to give help people deal with when @:(brand.name) with your friends and contacts. So that the user can use the device, or set up a connection between social media platforms or devices to @:(brand.name) accounts or social media when connected to the platform better @:(brand.name) services collect and use your contacts list information (name, address, email address, etc.) in @:(brand.name) improve the environment.",
    summary8_1:
      'The information you choose to provide @:(brand.name) in order to use certain online services or additional services',
    summary8_2:
      'If the request or participate in the selection of the site to request features or improved services, or other optional features, you can collect additional information about users in @:(brand.name).',
    summary8_3:
      'If the methods used to collect information from those services differ from those stated in this Privacy Policy, the information collected during a separate notice.',
    summary9_1:
      'Information for the user when using the "@:(brand.name) non-payment" service',
    summary9_2:
      'For some limited services may need to sign in or use your account settings to non-payment. @:(brand.name) will collect your personal data, all payment methods relevant device information, technology data, location information necessary for the user to complete the transaction. When you select the account owner and the payment for the non-trading, you can build and collect transaction information associated with your account.',
    summary9_3:
      'If the user while not the account owner and select the payment for the non-@:(brand.name) deal, collect and store all information you provide is used and shared in accordance with the information in this Privacy Policy.',
    summary10_1: 'User-specific information obtained from third parties',
    summary10_2:
      'From a third party, such as merchant, data providers, credit bureaus to the extent permitted by law, you can get the information.',
  },
  partner: {
    be_partner: 'Become a partner of @:(brand.name).',
    banner_text:
      'Shopping platform provider, marketplace, there is a billing support operators that require a payment service provider can be a partner of @:(brand.name).',
    banner_btn: 'To contact your account manager',
    benefit: '@:(brand.name) benefits that partners are entitled',
    benefit_1: 'Integration and technical support for building solutions',
    benefit_2:
      'Please feel free to contact our support team for you to get help in @:(brand.name) integration. @:(brand.name) developer portal can also be used as a resource.',
    benefit_3: 'Business growth through marketing opportunities',
    benefit_4:
      'Take advantage of the many marketing opportunities provided @:(brand.name) can attract potential customers.',
    traction: 'And towing payments around the world.',
    traction1:
      '@:(brand.name) partners are supporting an innovative platform for a smooth settlement of sellers to trust @:(brand.name).',
    traction_btn: 'More Partners',
    program: '@:(brand.name) Partner Program is free to join.',
    program_1:
      'Please fill out the online form, we will contact you in @:(brand.name).',
    program_2:
      'Please describe the operational and running business solutions.',
    program_3:
      'Please contact @:(brand.name) to discuss the necessary changes.',
    program_4:
      '@:(brand.name) integrate with and help ensure that they receive payment @:(brand.name).',
    program_btn: 'To contact your account manager',
    common_qa: 'FAQ',
    common_qa1: 'Is there any vendors @:(brand.name) partner?',
    common_qa1_text:
      '@:(brand.name) partner is the B2B (business-to-business) company that offers its customers solutions @:(brand.name). @:(brand.name) is working with organizations such as the shopping cart, web hosting companies, web developers, logistics providers, and digital marketing agency, payment gateway.',
    common_qa2: 'What @:(brand.name) partners eligible?',
    common_qa2_text: 'Contact your account manager',
    common_qa2_text_2:
      'You can get advice about the qualifications of the partners.',
    common_qa3: 'We provide integrated support services in the @:(brand.name)?',
    common_qa3_text:
      'Once registered in the partner program and @:(brand.name) approval to join, you can access the valuable integrated documentation and developer forums. It can also get integrated support for consultants for the certificate.',
    common_qa4:
      'There is also a business outside of Korea, can I sign up separately for each country in the Partner Program?',
    common_qa4_text:
      'It depends on the country you are operating a business. In @:(brand.name) are deploying specialized partner representative to the regional requirements in various countries.',
    common_qa4_more: 'View Partner Program provides national',
  },
  pay_main: {
    total_product: 'Total product',
    total_sum: 'sum',
    pay_this_account: 'Set this account as a payment method.',
    bill_show:
      'The transaction information is displayed as follows in the specification.',
    banner_text: '@:(brand.name) is more secure',
    banner_text2: 'A quick payment.',
    banner_text3:
      'No matter where shopping will keep your financial information secure.',
    footer_1: 'terms',
    footer_2: 'User Agreement',
    footer_3: 'Privacy Statement',
    footer_4: 'feedback',
    footer_5:
      'Notification to customers: the owners of prepaid means of payment @:(brand.name) ⓒ @:(brand.name) does not require the approval of the Australian Financial Supervisory Authority.',
    footer_6: 'Terms of Use',
    footer_7: 'We also encourage you to read it carefully.',
    footer_8: 'payment',
    wallet: 'E-wallet management',
    last_name: 'castle',
    card_number: 'card number',
    three_number: 'Three digits',
    name: 'name',
    pay_brand: 'To pay by @:(brand.name)',
    free_shipping:
      'If the @:(brand.name) account, you can get free return shipping, purchase protection.',
    email_phone: 'Email or phone number',
    login_error: 'Do you have trouble signing in?',
    pay_card: 'Payment by card',
    cancel_back: 'Cancel and go back to the previous page',
  },
  site_map: {
    site_map_tip:
      'A link that will help you explore the @:(brand.name) account.',
    map_fund: 'funds',
    map_fund_1: 'Debited',
    map_fund_2: 'My ability to use the balance is?',
    map_fund_3: 'Send or request money',
    map_fund_4: 'Call Management',
    map_fund_5: '@:(brand.name) my debit card discounts',
    map_fund_6: 'Get @:(brand.name) debit card',
    map_fund_7: '@:(brand.name) Credit Billing Schedule',
    map_deal: 'deal',
    map_deal_1: 'View all deals activity',
    map_deal_2: 'Activities views (including balance and fees)',
    map_deal_3: 'View Deal graphs and charts',
    map_deal_4: 'Download Deal',
    map_deal_5: 'In response to a claim or chargeback',
    map_deal_6: 'IPN (instant payment notification) History',
    map_profile: 'My Profile and Settings',
    map_profile_1: 'Business mirror',
    map_profile_2: 'Email, address, phone or password Update',
    map_profile_3: 'Bank account or card update',
    map_profile_4: 'Update Notifications',
    map_profile_5: 'View Account Limits',
    map_profile_6: 'User Management',
    map_profile_7: 'Delivery Update Preferences',
    map_support: 'support',
    map_support_1: 'Go to the Center for Conflict Resolution',
    map_support_2: 'Go to Support Center',
    map_support_3: 'Contact Us',
    map_support_4: '@:(brand.name) merchant fee information',
    map_report: 'report',
    map_report_1: 'Report to set up, manage or download',
    map_manage: 'tool',
    map_manage_1: 'View tool',
    map_manage_2: '@:(brand.name) button management',
    map_manage_3: 'Regular Payment Management',
    map_consum: 'customer',
    map_consum_1: 'View Guest List',
  },
  fee: {
    fee_tip: 'Simple Fee Structure',
    fee_banner_1:
      'Generally, buying is free and may be subject to currency exchange fees.',
    fee_banner_2:
      'If sales do not stick with the @:(brand.name) monthly fees, or cancellation fees. After each commission will only be paid.',
    fee_h2: 'Typically purchase is free.',
    fee_text1: 'Fees for processing payments are paid by the seller.',
    fee_text2: 'However, you can exchange fee is applied.',
    fee_more: 'Seller fees learn more',
    fee_text3:
      'For sale by the invoice or payment Email Web site (international payment standard rates apply)',
    fee_text4: 'A fixed fee based on the receipt of calls',
    fee_text5: 'Exchange fees may apply additionally.',
    fee_text6:
      'For example, for a fixed fee payment receipt in USD it is $ 0.30 USD.',
  },
  dash: {
    more: 'See more',
    withdraw_asset: 'Funds withdrawal',
    currency: 'currency',
    quotes: 'Invoices and Estimates',
    last_6_months: 'Last 6 Months',
    make_invoice: 'Invoice generation',
    manage_invoice: 'Invoice Management',
    grown_up: 'Please send to grow the business for a quote.',
    un_paid_invocie: 'Outstanding invoices',
    make_quotes: 'Quote generation',
    quotes_1: 'One has suggested any outstanding invoices.',
    quotes_2: '@:(brand.name) invoice',
    quotes_alarm: 'Send reminders',
    quotes_detail: 'Show more',
    quotes_who: 'Bill to: Choi, So - Young',
    latest_act: 'Recent Activity',
    act: 'activity',
    received: 'Received Payment',
    send: 'From Payment',
    act_record: 'Activity (including balance and fees)',
    pay_person: "Biller's name",
    show_all: 'View all',
    tell_us: 'Please tell us your opinion.',
    feed_text:
      'Please take a moment to tell us your opinion on the newly designed display information on this page. Thank you!',
    service: 'Provide feedback',
    feed_text_back:
      'Thank you for your feedback! Was this how our site is useful?',
    feed_placeholder:
      'Please let me know the reason I came today @:(brand.name) there is a better way. Do not include personal information, such as email or account number.',
    feed_p:
      '@:(brand.name) office staff and guests to your comments can be posted internally, so you can see it, do not leave any personal information. Customer service issues, please click here. Of @:(brand.name)',
    feed_protect: 'Privacy Policy',
    feed_law: 'Legal Conditions',
    feed_or: 'And',
    feed_need: 'Refer to the',
    trade_name: 'Deal name',
    trade_id: 'Deal ID',
    transaction_type: 'Deal Type',
    trade_amount: 'Amount of payment',
    detail_show: 'Example',
  },
  shop_detail: {
    detail_info: 'Shop Details',
    api_signature: 'Store signing key',
    msg_shop_create: 'This shop has been registered.',
    msg_shop_modify: 'This shop has been fixed.',
  },
  merchant_account: {
    create_account: 'Generate Settlement Account',
    enroll_account: 'Registration Settlement Account',
    pls_select_account: 'Choose Settlement Account',
  },
  transaction_detail: {
    transaction_title: 'Deal details',
    order_id: 'Shop Order Number',
    pay_account_title: 'Payment Account Name',
    pay_account_number: 'Payment Account Number',
    pay_account_balance: 'Payment Account Balance',
    pay_account_selection: 'Select payment account',
    pay_account_selection_msg: 'Please select a payment account.',
  },
  guide: {
    guide_title_1: '@:(brand.name) Account',
    guide_title_2: "How does @:(brand.name)'s transfer and remittance?",
    guide_title_3:
      "Take advantage of more convenient and safe service through @:(brand.name)'s account.",
    guide_strapline_1: '① Accounts that can be removed immediately without fee',
    guide_strapline_2: '② Easy to open quick account in easy way',
    guide_strapline_3: 'Vestigate',
    guide_strapline_4: 'remittance',
    guide_strapline_5:
      'Accounts that can deposit the most kinds of coins in Korea',
    guide_strapline_6: 'Safe account from hacking',
    guide_strapline_7: 'Visual history inquiry and receipt available',
    guide_strapline_8: 'Can be used as a corporate settlement account',
    guide_strapline_9:
      'Rapid transactions through accounts for C2C and B2C transactions',
    guide_strapline_msg_1:
      "@:(brand.name)'s account transfer does not occur for transferring money.",
    guide_strapline_msg_3: "@:(brand.name)'s account opening is 10 seconds.",
    guide_strapline_msg_4: 'Complex process omitted.',
    guide_strapline_msg_5:
      'You can create only the account name for that asset.',
    guide_strapline_msg_6: 'Transfer via wallet',
    guide_strapline_msg_7: 'Using wallet address',
    guide_strapline_msg_8: 'Fee charges',
    guide_strapline_msg_9: 'Remittance in @:(brand.name)',
    guide_strapline_msg_10: 'Using account number',
    guide_strapline_msg_11: 'Fee Zero',
    guide_strapline_msg_12:
      'Many types of cryptographic accumulations are being issued worldwide. @:(brand.name) is dealing with a variety of cryptographic accumulations to help customer convenience in accordance with these changes.',
    guide_strapline_msg_13:
      'Security is the core of cryptographic inclusions. @:(brand.name) thinks the most important security, and digital engineers with more than five years experience in each field have established a security system.',
    guide_strapline_msg_14:
      "You can query the transfer between accounts. @:(brand.name)'s account can check the banks between banks or other banks, such as market banks. If necessary, you can visit the point and check and output the issuance history.",
    guide_strapline_msg_15:
      "@:(brand.name)'s account is linked to @:(brand.group) Market's payment and settlement account. After registering the target cryptographic account as a settlement account, you can settle the goods sold in the @:(brand.group) Market to a cryptopaste.",
    guide_strapline_msg_16:
      "Fees and delays occur on the transaction between the individual through the wallet. @:(brand.name) offers @:(brand.name) account remittance as a way to solve this. Experience C2C and B2C transactions without fee and delay through @:(brand.name)'s account.",
  },
  account_transfer: {
    transfer: 'Transfer',
    transfer_list: 'View transfer result',
    transfer_list_title: '@:(brand.name) account transfer',
    transfer_list_wallet: 'Other wallet transfer',
    msg_required_data: 'Please enter all the values',
    msg_not_select_withdraw_account: 'Please select the payment account',
    create_transfer_title: 'Accounts transfer',
    from_account_select: 'Select payment account',
    available_transfer: 'Transfer amounts',
    to_account_input: 'Enter transfer account number',
    to_account_confirm: 'Transfer Account Verification',
    to_account_user_name: 'Transfer Account Member Name',
    transfer_amount: 'Transfer Amount',
    delete_amount: 'Correction',
    all_amount: 'FULL',
    description: 'Explanation',
    transfer_btn: 'Transfer',
    transfer_info_check: 'Check transfer request information',
    from_account_number: 'Withdrawal Account Number',
    from_asset_title: 'Withdrawal Account Assets',
    to_account_number: 'Transfer Account Number',
    success_transfer: 'Transfer has been processed successfully.',
    transfer_list_detail: 'View transfer result',
    search_transfer_asset: 'Search by property',
    search_transfer_account: 'Search by account',
    reset: 'Reset',
    search: 'Search',
    transfer_list_detail_tit: 'Transfer Details',
    no_transfer: 'No transfer details',
    msg_not_search_account:
      'Account number does not exist or is not valid input.',
    my_account_transfer: 'My account transfers',
    msg_pls_select_account: 'After selecting an asset, search the account.',
    placeholder_amount: 'Please enter the transfer amount',
    not_search_user_name: 'Not sure username',
    msg_select_asset_search: 'Please select an account',
    success_fail: 'The transfer was unsuccessful.',
    pls_search_asset: 'Search for assets.',
    pls_search_account: 'Search your account.',
    pls_select_asset: 'Please select an asset.',
    not_exist_account: "The asset's account does not exist.",
    favorites: 'Favorites',
    no_inquiry_history: 'There is no inquiry history.',
    account_number_list_1:
      '6 months ago the transfer history can not be queried.',
    account_number_list_2: 'The maximum number of views is 6 months.',
    account_number_list_3:
      'Presenting results The results of the results are the inquiry and merchant transfer results in @:(brand.name). <br /> If you want to view the results of the transfer with other wallet, please check with [wallet Transfer] on the top.',
    account_number_list_3_1:
      'The current transfer result inquiry is a page for inquiries within @:(brand.name) and the transfer results of affiliate stores. <br/>If you would like to check the transfer result to your @:(brand.name) account, please check the [@:(brand.name) account transfer] at the top.',
    today: 'Day',
    one_week: '1 week',
    one_month: '1 month',
    three_months: '3 months',
    six_months: '6 months',
    withdrawal_account_number: 'Withdrawal of account number',
    recent_order: 'recent order',
    past_order: 'past order',
  },
  bank_service_center: {
    title: 'title',
    date: 'date',
    state: 'state',
    enter_search_word: 'Please enter your search word',
    list: 'List',
  },
  service_center: {
    view_all: 'View all',
    contact_history: 'Inquiry details',
    privacy_Statement: 'Privacy Statement',
    would_you_agree: 'Would you like to agree to the above?',
    mobile_number: 'Mobile number',
    target_of_inquiry: 'Subject of inquiry',
    inquiry_contents: 'Inquiry contents',
    please_enter_your_inquiry: 'Please enter your inquiry.',
    send: 'send',
    normal_inquiries_received: 'Your inquiry has been successfully received.',
    inquiry_history: 'Inquiry history',
    pls_select_inquiry_type: 'Please select the type of contact',
    pls_login_to_use_inquiry: '1, Sign in to the first inquiries.',
    non_member_login: 'Non-member login',
    contact_id: 'Contact ID',
    view_inquiry: 'View contact',
    service_center: 'Customer center',
    inquiry_details: 'Contact Details',
    msg_enter_title: 'Please enter a title.',
    msg_enter_your_content: 'Please enter your information.',
    msg_pls_login: 'Please login.',
    go_back: 'Go back',
    re_contact: 'Contact Material',
    contents: 'Contents',
    msg_no_inquiry_history: 'No contact details.',
    msg_require_login_additional_authentication:
      'Please log-in or additional authentication is required.',
    when_you_member: 'If you are a member',
    msg_inquiry_history_can_view_after_login:
      "Member's inquiry details can be viewed after log-in.",
    non_member: 'If you are not a member',
    lookup_inquiry: 'Inquiry',
    msg_enter_inquiry_id: 'Please enter the contact ID.',
    msg_enter_password_when_registering_your_inquiry:
      'Please enter the password.',
    frequently_asked_questions: 'FAQ',
    msg_enter_your_password: 'Please enter your password.',
    pls_search_fap: 'Please search for questions.',
    msg_source_filename_none: 'There is no attached picture.',
    super_inquiry: 'Top Inquiry',
  },
  modal: {
    not_seeing_day: 'Not seen during the day',
  },
  login_guide_modal: {
    title: 'Instructions',
    sub_title:
      'To facilitate exchanges of using your sign will cause the system to reform.',
    content:
      '[Before change] <br/> first ID Login created when you sign up <br/><br/> [After change] <br/>  being used to change the phone number or e-mail login <br/> <br/> login before the system is reorganized how are logged in as haejusimyeon submitted written first accession ID.',
  },
  affiliate: {
    affiliate_occur_list: 'Allowance History',
    affiliate_adjust_list: 'Allowance settlement details',
    allowance_balance_asset: ' Allowance balance by asset',
    list_allowance_balance_asset: 'List of allowance balance by asset',
    search_by_asset: 'Search by asset',
    allowance_search: 'Allowance search',
    generator: 'Generator',
    beneficiary: 'Beneficiary',
    benefactor: 'Benefactor',
    behavior_type: 'Behavior type',
    target_unique_number: 'Target unique number',
    date_of_occurrence: 'Date of occurrence',
    application_policy_name: 'Application policy name',
    beneficiary_type: 'Beneficiary type',
    benefactor_type: 'Benefactor type',
    target_amount: 'Target amount',
    principal_amount: 'Principal amount',
    allowance: 'Allowance',
    allowance_assets: 'Allowance assets',
    allowance_amount: 'Allowance amount',
    affiliate_log: ' Allowance details',
    allowance_settlement: 'Allowance settlement',
    allowance_settlement_info: 'Allowance settlement information',
    name_asset_settled: 'Name of assets to be settled',
    balance_receive_payment: 'Balance to be paid',
    select_account_settled: 'Select account to be settled',
    no_affiliate_log: 'There is no allowance incurred.',
    no_affiliate_balance: 'There is no list of allowance balances by asset.',
    no_affiliate_adjust: 'There is no allowance payment history.',
    asset_name: 'Asset name',
    asset_code: 'Asset code',
    balance: 'Balance',
    cumulative_amount: 'Cumulative amount',
    please_select_account: 'Please select an account.',
    calculate: 'Calculate',
    settle: 'Settle',
    calculate_amount: 'Settlement amount',
    account_number: 'Account Number',
    registration_date: 'Registration date',
    number: 'number',
  },
  coin_name: 'Coin name',
  main_function: 'Main Function',
  disclosure_ing: 'disclosure_ing',
  quick_service: 'Quick service',
  new_account: 'New account',
  social_login: 'Social login',
  way_to_find: 'The way to find',
  korea_head_office: '@:(brand.name) Korea Headquarters',
  branch_office: '@:(brand.name) Sinsa branch',
  address_head_office: '528 Eonju-ro, Gangnam-gu, Seoul',
  address_branch_office: '803 Nonhyeon-ro, Gangnam-gu, Seoul',
  map: 'map',
  korean_language_counseling: 'Korean Consultation',
  hours_of_business: 'Virgin Islands 10:00-18:00 (excluding bank holidays)',
  overseas_consultation: 'Overseas Consultation',
  email_consultation: 'Email Consultation',
  exchange_price: 'Cryptocurrncy exchange/price',
  market_price_check: 'Check market price',
  full_account_inquiry: 'Inquire full account',
  exchange_details_check: 'View exchange details',
  cryptocurrency_exchange_history: 'Cryptocurrency exchange history',
  deposit_account_inquiry: 'View fund deposit account',
  dormant_account_check: 'Dormant account check',
  account_and_other_case_status:
    'Check @:(brand.name) account and other case status',
  account_and_other_wallet:
    'Check @:(brand.name) account and other case status',
  account_search: '@:(brand.name) Account Inquiry',
  other_wallet_search: 'Other Wallet Transfer',
  error_remittance: 'Consent to return the error remittance in @:(brand.name)',
  transfer: 'Transfer',
  transfer_result_check: 'View transfer result',
  other_wallets_transfer: 'View other wallet transfer result',
  other_wallets_transfer_search: 'View other wallets transfer result',
  frequently_used_accounts: 'Register/manage frequently used accounts',
  new_demand_account: 'Open a new account',
  new_installment_savings_account: 'New installment savings account',
  new_deposit_account: 'New time deposit account',
  check_account_progress_account:
    'Check new account progress status of the account',
  download: 'Download',
  withdrawal: 'Withdrawal',
  Smart_window_withdrawal: 'Smart window withdrawal',
  smart_ATM_withdrawal: 'Smart ATM withdrawal',
  customer_service: 'Customer Service',
  notice: 'Notice',
  one_one_inquiry: '1:1 inquiry',
  inquiry_details: 'Inquiry details',
  frequently_asked_questions: 'FAQ',
  server_notice: 'Server notice',

  service_hours: 'Customer service operation time',
  all_day_long: '(Contact us 24 hours)',
  online_service_hours: 'Online bank hours',
  unusable_hours: '24/7/365 (except 23:30-24:00)',
  offline_hours: 'Offline bank hours',
  offline_bank_hours: '(except weekend and holidays)',

  management: 'management',
  secure_management: 'Secure Authentication/Management',
  fund_limit_management: 'Fund limit management',
  issue_details_check: 'Issue details check',
  part_of_news: 'This is the part of the news.',
  part_of_notice: 'This is the part of the announcement.',
  full_menu: 'Full menu',
  individual: 'Individual',
  key_coin:
    "@:(brand.name)'s key coin that connects cryptocurrency to real currency",
  limitation_info:
    'Guideline on limit restrictions for prevention of telecommunications financial fraud',
  limitation_info_1:
    'As a demand payment account is opened non-face-to-face, the withdrawal (transfer) limit through automated devices and the Internet is limited to {0} USOT per day.',
  limitation_info_2:
    'Objective authentication data to confirm the transaction purpose can be presented to the branch and the limit can be lifted in “Management> Security Authentication/Management”.',
  limitation_info_3:
    'When using Internet banking, you must register with a withdrawal account to make a transfer transaction.',
  limitation_info_4: 'Only 5 accounts can be opened per cryptocurrency limit.',
  limitation_notice: 'Notice',
  limitation_notice_1:
    'Internet banking subscription can be applied by linking from the completion screen after opening a deposit and withdrawal account.',
  limitation_notice_2:
    'Please note that existing Internet banking customers can register for withdrawal accounts through Internet banking only when the withdrawal account registration category is Internet + branch.',
  limitation_notice_3:
    '* You must finish secure authentication to make the transfer transaction easier through Internet banking. Please open an account and register the withdrawal account after improving certification rate.',
  new_subscription: 'New Subscription',
  new_subscription1_1: 'When you click the new subscription button,',
  new_subscription1_2:
    'account and deposit address linked to an external wallet will be issued.',
  new_subscription2_1:
    'Be sure to know before depositing! There are no fees if you transfer money from an account dedicated to @:(brand.name) to your account. Only',
  new_subscription2_2:
    'can be deposited to the account/address issued upon new registration. Any errors/losses that may occur if you attempt to deposit other digital assets to the address are irrecoverable. After the first confirmation has occurred, it is reflected in the balance through the deposit process. The deposit process is automatic and the time required may vary depending on network conditions. The above sculpture is a deposit-only address.',
  new_subscription3_1: 'You can deposit',
  new_subscription3_2: 'for new subscriptions assigned to you.',
  new_subscription4: 'Did you agree and understand the above?',

  created_account_number: 'Created account number',
  exclusive_account: '@:(brand.name) exclusive account number',
  depositing_external_wallet:
    'When depositing @:(brand.name) from an external wallet',
  use: 'To use',
  we_future: 'our future',
  pop_brand: '@:(brand.name)',
  fourth_industry: 'Leader in the fourth industry',
  oc_15: 'October 15',
  officially_open: 'Officially open!',
  head_branch_office:
    'Korea Head Office (Jamsil Branch) / 1st Branch (Sinsa Branch)',
  sep_15: 'September 15th at 5pm',
  open_popup: 'OPEN',
  thanks_for: 'Thank you for your encouragement.',

  direct_exchange: {
    sell_buy_assets: 'Assets to sell and buy',
    replace_assets: 'Assets to exchange',
    ccm_exchange_rate: 'CCM preferential exchange rate',
    buy_sell_percent: 'Buy -10% Sell +10%',
    expected_property: 'Expected',
    preferential_property: 'Applied',
  },

  event_banner: {
    month_hotcoupon: "Check out this month's HOT coupon",
    hotcoupon_sub: 'From exchange rates to various affiliate coupons!',
    grab_bug: 'Catch the bug',
    grab_bug_sub:
      'Please leave a 1:1 inquiry. Prizes are given through lottery.',
    event2_sub_title: 'Higher rates.<br>Even higher returns.',
    event2_title: '',
    event2_text:
      'Become a member of <span style="font-weight: 700">CCM</span><br>and <span style="font-weight: 700">receive a dividend!</span><br>Take advantage of this great offer!',
    event2_btn: 'Join',
  },
  news_lists: {
    news_list_1:
      '프라비코, iq옵션과 같은 방대한 트렌젝션을 일으키는 거래소가 될 것',
    news_list_2:
      'GCC 코인 10월 15일 포블게이트에 상장. 비트코인처럼 안정화 된 코인이 목표',
    news_list_3: '프라비코, 의료산업에 블록체인 기술 접목한다',
    news_list_4: '디파이 열풍! 그 명과 암',
    news_list_5:
      '은행을 대체할 수 있을까? 블록체인 보관과 검증은 어떻게 이루어지나',
    news_list_6: '블록체인은 식품 유통에 혁신적인 발전을 가져올 것이다',
    news_list_7: '가장 혁명적인 화폐 비트코인 탄생 배경은?',
  },
  pop_notice: {
    notice_close: 'Close',
    notice_today: "Don't see today",
  },
}
